// Small pill-style tab switcher shared by pages that merge a
// pharmacy-sourced and clinic-sourced view (Prescriptions, Invoices).
export default function SectionTabs({ tabs, active, onChange }) {
  return (
    <div style={{ display: "flex", gap: 8, marginBottom: 18, flexWrap: "wrap" }}>
      {tabs.map(({ key, label, icon, count }) => (
        <button
          key={key}
          onClick={() => onChange(key)}
          style={{
            display: "flex", alignItems: "center", gap: 7,
            padding: "8px 16px", borderRadius: 20, fontSize: 13, fontWeight: 600,
            border: `1.5px solid ${active === key ? "var(--brand-primary)" : "var(--border-color)"}`,
            background: active === key ? "var(--brand-primary)" : "transparent",
            color: active === key ? "white" : "var(--text-secondary)",
            cursor: "pointer", fontFamily: "inherit", transition: "all 0.15s",
          }}
        >
          {icon && <i className={`pi ${icon}`} style={{ fontSize: 12 }} />}
          {label}
          {count != null && (
            <span style={{
              background: active === key ? "rgba(255,255,255,0.25)" : "var(--surface-bg)",
              borderRadius: 10, padding: "0 7px", fontSize: 11,
            }}>{count}</span>
          )}
        </button>
      ))}
    </div>
  );
}
